import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwaggerAuthService } from '../../services/auth.service';

/**
 * Swagger Not Found Component
 * 
 * Component displaying 404 Not Found error page.
 * Shown when user navigates to a non-existent route.
 * 
 * Features:
 * - Clean, user-friendly error page
 * - Navigation options
 * - Helpful suggestions
 */
@Component({
    selector: 'swagger-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: true
})
export class SwaggerNotFoundComponent implements OnInit {
    private readonly router: Router;
    private readonly authService: SwaggerAuthService;

    companyName: string = '';

    constructor(
        router: Router,
        authService: SwaggerAuthService
    ) {
        this.router = router;
        this.authService = authService;
    }

    ngOnInit(): void {
        this.loadBrandingSettings();
    }

    /**
     * Load branding settings from configuration
     */
    private loadBrandingSettings(): void {
        const settings = this.authService.getSettings();
        if (settings.branding) {
            this.companyName = settings.branding.companyName || settings.branding.platformName || 'Platform';
        }
    }

    /**
     * Get current year for footer
     */
    getCurrentYear(): number {
        return new Date().getFullYear();
    }

    /**
     * Navigate to home/dashboard
     */
    goToHome(): void {
        this.router.navigate(['/']);
    }

    /**
     * Navigate back to previous page
     */
    goBack(): void {
        window.history.back();
    }
}
